import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTypeformRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 31 31",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M15.7 7.6h3.6q2.6 0 5.1.3c2.3.5 3 2 3 4.2v4.2c0 4.6.3 7-5 7.2h-4.5l-4.1-.2c-2.3-.4-3-1.8-3.1-4v-4.2q-.1-2.3.1-4.3c.4-2.7 2.7-3 4.9-3.2m-10.2.1q1-.1 2 .4c1.4 1 1.3 3 1.3 4.5v5.7c0 1.9.1 4.7-2.3 5.2-3.4.3-3.2-3-3.2-5.3v-5.6c0-1.9-.1-4.4 2.2-5" })
});
export default SvgTypeformRegularIcon;
